import type React from "react";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: React.ReactNode;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, className }) => (
  <div
    className={`text-center py-[60px] px-5 text-muted-foreground${className ? ` ${className}` : ""}`}
  >
    {icon !== undefined && <div className="text-6xl mb-5 text-muted-foreground">{icon}</div>}
    {title && <h3 className="text-2xl text-foreground mb-2.5">{title}</h3>}
    {description && <div className="text-base text-muted-foreground">{description}</div>}
  </div>
);

export default EmptyState;
